import {Reducer} from "../../lib/redux";
import {TranslationActions} from "./actions";
import {TranslationActionTypes} from "./types";
import {ITranslations} from "../../model/Translation";

export let defaultTranslations: ITranslations = {
    sentenceDirectory: {},
    language: "en"
};

export let translations: Reducer<ITranslations, TranslationActions> = (state = defaultTranslations, action) => {
    switch (action.type) {
        case TranslationActionTypes.CLEAR_TRANSLATIONS: {
            return {
                ...state,
                language: action.payload.language ?? "en",
                sentenceDirectory: {}
            };
        }
        case TranslationActionTypes.SET_TRANSLATIONS: {
            if (!action.payload.sentenceDirectory){
                return state;
            }
            return {
                ...state,
                sentenceDirectory: {
                    ...state.sentenceDirectory,
                    ...action.payload.sentenceDirectory
                }
            };
        }
        default:
            return state;
    }
};